function loadScript(url, attributes = {}) {
  return new Promise((resolve, reject) => {
    const head = document.head || document.getElementsByTagName("head")[0];
    const script = document.createElement("script");

    // Set default attributes
    script.src = url;
    script.async = true;
    script.defer = true;

    // Apply additional attributes
    Object.keys(attributes).forEach((key) => {
      script.setAttribute(key, attributes[key]);
    });

    head.appendChild(script);

    script.onload = resolve;
    script.onerror = reject;
  });
}

// Function to set user data in PopupSmart
function setPopupSmartUserData(user) {
  if (!user || !window.ps) return;

  try {
    // Add user data as meta fields
    window.ps.addMeta("username", user.username || "");
    window.ps.addMeta("firstName", user.firstName || "");
    window.ps.addMeta("lastName", user.lastName || "");
    window.ps.addMeta("email", user.username || ""); // Assuming username is email
    window.ps.addMeta("organizationName", user.defaultOrganization?.name || "");
    window.ps.addMeta("userId", user.id || "");
  } catch (error) {
    console.error("Failed to set PopupSmart user data:", error);
  }
}

// Function to initialize PopupSmart with retry mechanism
function initializePopupSmartData() {
  const STORE_USER = "currentUser";
  let retryCount = 0;
  const maxRetries = 20;
  const interval = 500;

  const intervalId = setInterval(() => {
    if (window?.ps) {
      // Get user data from localStorage
      const userString = window.localStorage.getItem(STORE_USER);

      if (userString) {
        try {
          const user = JSON.parse(userString);
          setPopupSmartUserData(user);
        } catch (error) {
          console.error("Failed to parse user/billing data:", error);
        }
      }
      clearInterval(intervalId);
    } else {
      retryCount++;
      if (retryCount >= maxRetries) {
        clearInterval(intervalId);
        console.warn("PopupSmart ps object not found, retries stopped.");
      }
    }
  }, interval);
}

async function install(Vue) {
  const popupSmartId = import.meta.env.VUE_APP_POPUPSMART_ID;

  if (!popupSmartId) {
    return;
  }

  try {
    await loadScript("https://cdn.popupsmart.com/bundle.js", {
      "data-id": popupSmartId,
    });

    // Initialize user data after script loads
    initializePopupSmartData();

    // Make functions available globally
    Vue.prototype.$popupSmart = {
      setUserData: setPopupSmartUserData,
      updateUserData: initializePopupSmartData,
    };
  } catch (error) {
    console.error("Failed to load PopupSmart:", error);
  }
}

export default {
  install,
  setPopupSmartUserData,
  initializePopupSmartData,
};

export { setPopupSmartUserData, initializePopupSmartData };
